import { connect } from 'react-redux';

import { changePage } from 'actions';

import BattingPositionLeadersPage from './BattingPositionLeadersPage';

const mapStateToProps = state => ({
    teams: state.data.teams
});

const mapDispatchToProps = dispatch => ({
    browserBack: (pathname, params) => dispatch(changePage(pathname, params))
});

const BattingPositionLeaders = connect(mapStateToProps, mapDispatchToProps)(BattingPositionLeadersPage);

export default BattingPositionLeaders;



// WEBPACK FOOTER //
// ./src/views/batting-position-leaders/index.js